import ApplicationAdapter from './application';

export default class PaymentLink extends ApplicationAdapter {
  async queryRecord(id) {
    let url = this.buildURL('payment-link', id);
    let payload = await this.ajax(url, 'GET');
    this.store.pushPayload(payload);

    return this.store.peekRecord('payment-link', payload.data.id);
  }
}
